import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import cartPositionReducer from "./cartPositionReducer";
import flashMessageReducer from "./flashMessageReducer";
import categoryReducer from "./categoryReducer";
import settingReducer from "./settingReducer";
import pageReducer from "./pageReducer";
import productReducer from "./productReducer";
import customerReducer from "./customerReducer";
import cartReducer from "./cartReducer";
import orderReducer from "./orderReducer";
import sliderReducer from "./sliderReducer";
import announcementReducer from "./announcementReducer";
import categoryNavigationReducer from "./categoryNavigation";
import categoryShowcaseReducer from "./categoryShowcaseReducer";
import blogReducer from "./blogReducer";

export default combineReducers({
  router: routerReducer,
  cartPosition: cartPositionReducer,
  category: categoryReducer,
  product: productReducer,
  customer: customerReducer,
  cart: cartReducer,
  order: orderReducer,
  slider: sliderReducer,
  categoryNavigation: categoryNavigationReducer,
  categoryShowcase: categoryShowcaseReducer,

  announcement: announcementReducer,

  setting: settingReducer,
  page: pageReducer,
  blog: blogReducer,

  //
  flashMessage: flashMessageReducer,
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js